import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, getPackageShape, packageExports, packageName, } = linkedPackage('lincd-irlcg');
//# sourceMappingURL=package.js.map